module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product21-a46da1465f681d0bcbfcf3571ad6d62b.jpg";